// URL validation to prevent Open Redirect attacks
export const validateRedirectPath = (path) => {
  if (!path || typeof path !== 'string') return false;
  
  // Must be internal path starting with /
  if (!path.startsWith('/')) return false;
  
  // Prevent protocol-relative URLs
  if (path.startsWith('//')) return false;
  
  // Prevent data URLs, javascript URLs, etc.
  if (path.includes(':')) return false;
  
  // Prevent path traversal
  if (path.includes('../') || path.includes('..\\')) return false;
  
  return true;
};

export const validateDomain = (url) => {
  if (!url || typeof url !== 'string') return false;
  
  try {
    const urlObj = new URL(url);
    const allowedDomain = process.env.REACT_APP_ALLOWED_DOMAIN;
    
    if (!allowedDomain) return false;
    
    return urlObj.hostname === allowedDomain;
  } catch {
    return false;
  }
};